import { contentFactoryMap } from "../constants";

const heb = {
  name: "עברית",
  code: "heb",
  direction: "rtl",
  pages: {
    login: {
      title: "ברוכים הבאים ל-LTS Admin!",
      subtitle: "אנא התחבר כדי להמשיך.",
      email: "אימייל",
      password: "סיסמה",
      login: "התחברות",
      error: "שם משתמש או סיסמה שגויים",
    },
    queue: {
      title: "סטטוס משימות",
      inPageTitle: {
        short: "משימות",
        long: "סטטוס משימות",
      },
      subtitle: "סטטוס וניהול פריטי התור",
      refresh: "רענן",
      refreshed: "התור רוענן",
      tabs: {
        all: "הכל",
        pending: "ממתין",
        processing: "בעבודה",
        completed: "הושלם",
        failed: "נכשל",
      },
      actions: {
        downloadSource: "הורד את סרטון המקור",
        downloadFailed: "הורדת סרטון המקור נכשלה",
        retry: "הרץ שוב",
        retrySuccess: "המשימה הוכנסה לתור מחדש",
        retryFailed: "ההרצה מחדש נכשלה",
      },
    },
    highlights: {
      title: "הילייטים",
      inPageTitle: {
        short: "הילייטים",
        long: "הילייטים מועמדים",
      },
      subtitle:
        "בחירת רגע מפיקה כתבה אוטומטית. מועמדים שלא נבחרו נמחקים אחרי 14 יום.",
      refresh: "רענן",
      refreshed: "הרשימה רוענה",
      rtlToggle: "ימין לשמאל",
      copyLink: "העתק קישור למועמד זה",
      linkCopied: "הקישור הועתק",
      backToAll: "כל המועמדים",
      focusNotFound: {
        title: "המועמד לא נמצא",
        subtitle:
          "ייתכן שהקישור מפנה למועמד שמוזג או הוסר. חזרו כדי לראות את כל המועמדים.",
      },
      titleChoice: {
        label: "כותרת הכתבה",
        engine: "סופי",
        candidate: "טיוטה",
        applied: "הכותרת עודכנה",
      },
      picked: "נבחר — הפקת הכתבה החלה",
      pickedAgain: "נבחר — הכתבה כבר הופקה",
      unpicked: "הוחזר לממתינים",
      generateQueued: "ההפקה נכנסה לתור",
      merge: {
        warn: "ייתכן כפילות",
        of: "אותו סיפור כמו",
        action: "מזג",
        merging: "ממזג…",
        merged: "מוזגו לכתבה אחת",
        loadError: "טעינת הקליפ המוצע נכשלה",
        mergedFrom: "מוזג מ-",
        clips: "קליפים",
      },
      tabs: {
        pending: "ממתינים",
        picked: "נבחרו",
      },
      filter: {
        show: "תוכנית",
        all: "כל התוכניות",
        noMatch: "אין תוכנית תואמת",
        search: "חיפוש",
        searchPlaceholder: "כותרת, תקציר, תוכנית…",
        from: "מ-",
        to: "עד",
        clear: "נקה",
        date: {
          label: "תאריך",
          allTime: "כל התאריכים",
          today: "היום",
          yesterday: "אתמול",
          last7: "7 הימים האחרונים",
          thisMonth: "החודש",
          custom: "טווח מותאם",
          apply: "החל",
          from: "מ-",
          to: "עד",
        },
      },
      columns: {
        status: "סטטוס",
        show: "תוכנית",
        title: "כותרת",
        startedAt: "שעת שידור",
        duration: "משך",
      },
      generation: {
        running: "הכתבה בהפקה…",
        failed: "ההפקה נכשלה",
      },
      actions: {
        pick: "בחר",
        picking: "מבצע…",
        unpick: "בטל בחירה",
        retry: "נסה שוב",
        working: "מבצע…",
        viewArticle: "פתח כתבה",
      },
      empty: {
        pending: {
          title: "אין מועמדים ממתינים",
          subtitle:
            "כשההיילייטר ימצא רגעים ראויים לכתבה, הם יופיעו כאן.",
        },
        picked: {
          title: "עדיין לא נבחרו פריטים",
          subtitle:
            "בחירת מועמד מתחילה את הפקת הכתבה — הנבחרים והכתבות שלהם מרוכזים כאן.",
        },
        search: {
          title: "אין תוצאות",
          subtitle: "אף מועמד לא תואם את הסינון, בשתי הלשוניות.",
        },
      },
      runs: {
        title: "ריצות הקלטה",
        tooltip: "היסטוריית ריצות ההקלטה",
        empty: "עדיין לא נרשמו ריצות",
        clips: "קטעים",
        noShow: "התוכנית לא זוהתה",
        status: {
          running: "פעיל",
          completed: "הושלם",
          empty: "אין קטעים",
          failed: "נכשל",
        },
      },
    },
    clipToArticle: {
      title: "קטע לכתבה",
      subtitle:
        "הפכו כל קטע מהקלטות 4 הימים האחרונים לכתבה.",
      refresh: "רענן",
      untitled: "הקלטה ללא שיוך",
      today: "היום",
      yesterday: "אתמול",
      back: "כל התוכניות",
      aired: "שודר",
      showWindowLabel: "התוכנית בתוך ההקלטה",
      playhead: "סמן הניגון",
      start: "התחלה",
      end: "סיום",
      length: "אורך",
      setStart: "קבע התחלה (I)",
      setEnd: "קבע סיום (O)",
      setStartHint: "מעביר את ההתחלה למקום שבו נמצא סמן הניגון. קיצור: I",
      setEndHint: "מעביר את הסיום למקום שבו נמצא סמן הניגון. קיצור: O",
      preview: "נגן את הקטע",
      stop: "עצור",
      reset: "איפוס",
      invalidTime: "פורמט: M:SS או H:MM:SS",
      generate: "צור כתבה",
      confirm: {
        title: "ליצור כתבה מהקטע הזה?",
        show: "תוכנית",
        body: "הכתבה נכתבת מהקטע שנבחר. זה לוקח כמה דקות.",
        cancel: "ביטול",
        ok: "כן, צור כתבה",
      },
      queued: "נשלח לתור — הכתבה תופיע בתוכן בעוד כמה דקות. אפשר לעקוב בעמוד התור.",
      tooLong:
        "הקטע חורג ב-{over} מהמגבלה של 15 דקות. קטעים ארוכים מפיקים כתבות חלשות ועולים הרבה.",
      tooShort: "הקטע קצר מדי — נדרשות לפחות {min}.",
      empty: {
        title: "אין תוכניות ב-4 הימים האחרונים",
        subtitle: "הן יופיעו כאן אחרי ההקלטה המתוזמנת הבאה.",
      },
    },
    recordings: {
      title: "הקלטות",
      subtitle:
        "הקלטות שנשמרו, נשמרות 14 יום. אפשר להריץ עליהן שוב את ההיילייטר ולקבל מועמדים חדשים.",
      refresh: "רענן",
      rerun: "הרץ היילייטר",
      selected: "{n}/{max} נבחרו",
      launched:
        "הופעלו {n} ריצות היילייטר — מועמדים חדשים יופיעו בעמוד ההילייטים תוך 10–20 דקות.",
      launchFailed: "{n} הקלטות לא הופעלו",
      columns: {
        date: "תאריך",
        window: "חלון",
        show: "תוכנית",
        size: "גודל",
      },
      runs: {
        label: "ריצות",
        title: "היסטוריית ריצות",
        empty: "לא נרשמו ריצות להקלטה הזו",
        clips: "קטעים",
        rerun: "ריצה חוזרת",
        status: {
          running: "פעיל",
          completed: "הושלם",
          empty: "אין קטעים",
          failed: "נכשל",
        },
      },
      empty: {
        title: "אין עדיין הקלטות",
        subtitle: "הן יופיעו כאן אחרי ריצת ההקלטה המתוזמנת הבאה.",
      },
    },
    home: {
      title: "דף הבית",
      subtitle: "מה קורה במרחב העבודה שלך היום.",
      greeting: {
        morning: "בוקר טוב",
        afternoon: "צהריים טובים",
        evening: "ערב טוב",
      },
      viewAll: "הצג הכל",
      rtlToggle: "ימין לשמאל",
      time: { now: "כעת", m: "ד׳", h: "ש׳", d: "י׳" },
      articles: { title: "מאמרים אחרונים", empty: "אין עדיין מאמרים" },
      recordings: {
        title: "הקלטות היום",
        empty: "אין הקלטות מתוכננות להיום",
        planned: "מתוכנן",
        recording: "מקליט",
        captured: "הוקלט",
        failed: "נכשל",
      },
      highlights: { title: "היילייטים", empty: "אין מועמדים ממתינים" },
      trendscout: { title: "נושאים חמים", empty: "אין עדיין טרנדים" },
      todaybefore: {
        title: "היום לפני",
        empty: "אין אירועים להיום",
        yearsAgo: "לפני {n} שנים",
      },
      activity: {
        title: "פעילות אחרונה",
        empty: "אין פעילות אחרונה",
        article: "מאמר חדש",
        highlight: "היילייט חדש",
        trend: "טרנד זוהה",
        recording: "הקלטה נלכדה",
      },
    },
    storehouse: {
      title: "מאגר מדיה",
      subtitle: "מאגר מדיה. לחץ להעתקה, לחץ פעמיים לפתיחה",
      alert: "התוכן המוצג מסונן בהתאם להרשאות המשתמש ובעלות התוכן שלך.",
      sync: "סנכרן",
      upload: {
        short: "העלה",
        long: "העלה תמונה",
      },
      uploadDialog: {
        title: "העלה תמונה",
        description: "כדי להעלות קובץ, אנא בחר אותו מהמכשיר שלך.",
        instructions: "גרור ושחרר תמונות לכאן, או לחץ לבחירת קבצים",
        upload: "העלה",
        cancel: "ביטול",
      },
    },
    campaigns: {
      title: "קמפיינים",
      subtitle: "נהל, צור וערוך קמפיינים",
      alert: "הדף בפיתוח",
    },
    automations: {
      title: "אוטומציות",
      subtitle: "נהל, צור וערוך אוטומציות",
      alert: "הדף בפיתוח",
    },
    stream: {
      title: "שידור",
      subtitle: "ניהול שידור חי",
      days: {
        abbr: ["א׳", "ב׳", "ג׳", "ד׳", "ה׳", "ו׳", "ש׳"],
        today: "היום",
      },
      errors: {
        showAlreadyStarted: "לא ניתן לשנות תוכנית שכבר החלה",
        saveFailed: "שמירת התוכנית נכשלה",
        removeFailed: "הסרת התוכנית נכשלה",
        guideUnavailable: "לוח השידורים אינו זמין כעת. אנא נסה שוב מאוחר יותר.",
      },
      success: {
        saved: "התוכנית נשמרה בהצלחה",
        removed: "התוכנית הוסרה בהצלחה",
        recurringSaved: "הקלטה חוזרת נוצרה",
      },
      record: {
        thisAiring: "שידור זה",
        recordOnce: "הקלט שידור זה",
        remove: "הסר הקלטה",
        repeatWeekly: "חזרה שבועית",
        pickDays: "בחר את הימים להקלטת משבצת זמן זו",
        setupRepeat: "הגדר חזרה",
        repeatsOn: "חוזר:",
        stopRepeating: "הפסק חזרה",
        includeReruns: "כלול שידורים חוזרים (ש.ח)",
        rerunConfirm: {
          title: "להקליט גם שידורים חוזרים?",
          message:
            "כברירת מחדל, הקלטה חוזרת מדלגת על שידורים חוזרים (ש.ח). לאשר הקלטה גם של שידורים חוזרים?",
          confirm: "כן, כלול",
          cancel: "ביטול",
        },
        close: "סגור",
        status: {
          scheduled: "מתוזמן",
          recording: "מקליט",
          captured: "הוקלט",
          failed: "נכשל",
          recurring: "חוזר",
        },
      },
    },
    settings: {
      title: "הגדרות",
      subtitle: "הגדרות מנהל",
      save: "שמור",
      tabs: {
        recording: "הקלטה",
        models: "מודלים",
      },
      models: {
        heading: "מודלים",
        help: "באיזה מודל כל יכולת רצה. מודלי הגיבוי קבועים — קריאה שנכשלת עדיין מנסה שוב מול הגיבוי.",
        defaultTag: "ברירת מחדל",
        overridden: "שונה",
        loadFailed: "טעינת המודלים נכשלה",
        features: {
          trendscoutScan: {
            label: "סריקת TrendScout",
            description: "סינון RSS וכותרות בעברית, כל שעה. הריצה עם הנפח הגבוה ביותר.",
          },
          todaybefore: {
            label: "היום לפני",
            description: "תרגום לעברית של פיד האירועים ההיסטוריים.",
          },
          assistant: {
            label: "עוזר העריכה",
            description: "הצ׳אט בתוך העורך. רץ בכל הודעה.",
          },
          reshetJudge: {
            label: "זיהוי תוכנית חוזרת",
            description: "משייך תוכנית ששמה השתנה ללוח השידורים. פעם ביום לכל תוכנית לא מזוהה.",
          },
          v2aVision: {
            label: "ניתוח וידאו",
            description: "צפייה בקליפ ב-video2article. ברירת המחדל להעלאות ולהיילייטס.",
          },
          writingEngine: {
            label: "מנוע הכתיבה",
            description: "כותב את הכתבה עצמה (TrendScout, היום לפני, video2article). ל-Claude ול-DeepSeek נדרש מפתח API על הוורקר.",
          },
        },
      },
      recording: {
        heading: "הקלטה",
        padLabel: "ריפוד (דקות)",
        padHelp:
          "דקות נוספות שמוקלטות לפני ואחרי כל תוכנית, משני הצדדים. חל על כל הקלטה מתוזמנת.",
        clipPadLabel: "ריפוד קליפ (שניות)",
        clipPadHelp: "שניות פתיחה / סיום לכל קליפ",
        guideRefreshLabel: "רענון לוח שידורים (דקות)",
        guideRefreshHelp:
          "כל כמה זמן לוח השידורים נטען מחדש והתוכנית של היום מותאמת אליו שוב. ערך נמוך עוקב מהר יותר אחרי שינויים במהלך היום; חלונות שכבר מקליטים לעולם לא זזים.",
      },
      success: { saved: "ההגדרות נשמרו" },
      errors: {
        invalidPadding: "הריפוד חייב להיות בין 0 ל-60 דקות",
        invalidClipPadding: "ריפוד הקליפ חייב להיות בין 0 ל-30 שניות",
        invalidGuideRefresh: "רענון לוח השידורים חייב להיות בין 1 ל-720 דקות",
        saveFailed: "שמירת ההגדרות נכשלה",
      },
    },
    player: {
      title: "נגן וידאו",
      subtitle: "צפה בוידאו הממוסגר",
      error: "טעינת הוידאו נכשלה",
      notFound: "לא נמצא וידאו עבור תוכן זה",
      editor: "עורך",
    },
    reframeEditor: {
      toolbar: {
        title: "עורך ריפריים",
        back: "חזרה לתוכן",
        scene: "אסטרטגיה:",
        split: "פצל סצנה",
        merge: "מזג",
        mergeSelected: "מזג נבחרים",
        undo: "בטל",
        redo: "בצע מחדש",
        save: "שמור והוסף לתור",
        saving: "מוסיף לתור...",
        autoCutLabel: "חיתוך אוטומטי",
        autoCut: "מעבר אוטומטי בין דוברים פעילים",
        noScene: "לא נבחרה סצנה",
        multiSelected: "{n} סצנות נבחרו",
        clipboardChip: "מסגרת בלוח",
        overlay: "אוברליי",
        shortcuts: "קיצורי מקלדת",
      },
      shortcutsDialog: {
        title: "קיצורי מקלדת",
        groups: {
          playback: "ניגון",
          crop: "מסגרת",
          scenes: "סצנות",
          editing: "עריכה",
        },
        playPause: "ניגון / השהיה",
        frameStep: "פריים אחורה / קדימה",
        seekStart: "קפיצה להתחלה",
        seekEnd: "קפיצה לסוף",
        nudge: "הזזת המסגרת בפיקסל אחד",
        nudgeFast: "הזזת המסגרת ב-10 פיקסלים",
        copyCrop: "העתקת מסגרת",
        pasteCrop: "הדבקת מסגרת",
        prevNextScene: "הסצנה הקודמת / הבאה",
        split: "פיצול הסצנה במיקום הפלייהד",
        mergeNext: "מיזוג עם הסצנה הבאה",
        mergePrev: "מיזוג עם הסצנה הקודמת",
        clearSelection: "ביטול בחירה מרובה",
        undo: "ביטול",
        redo: "ביצוע מחדש",
        help: "הצגת הרשימה הזו",
      },
      overlay: {
        title: "שכבת אוברליי",
        close: "סגור",
        save: "שמור אוברליי",
        none: "לא מוגדר אוברליי",
        add: "הוסף אוברליי",
        summaryTemplate: "תבנית",
        summaryTiming: "תזמון",
        timingFull: "לכל אורך הסרטון",
        timingFromStart: "{n} שניות ראשונות",
        timingRange: "מ-{start}שנ׳ עד {end}שנ׳",
      },
      strategies: {
        focus: "פוקוס",
        static: "סטטי",
        bouncing: "קפיצה",
        virtual_scene: "סצנה וירטואלית",
        undefined: "לא מוגדר",
        fallback: "ברירת מחדל",
      },
      preview: {
        label: "תצוגה 9:16",
      },
      timeline: {
        label: "ציר זמן",
        noScenes: "אין סצנות להצגה",
        sceneCount: "סצנות",
        contextMenu: {
          splitHere: "פצל במיקום הסמן",
          mergePrev: "מזג עם הקודמת",
          mergeNext: "מזג עם הבאה",
          mergeSelected: "מזג נבחרים",
          copyCrop: "העתק מסגרת",
          pasteCrop: "הדבק מסגרת",
          pasteCropMulti: "הדבק מסגרת לנבחרים ({n})",
          applyCropToAll: "החל מסגרת על כל הסצנות",
          resetScene: "אפס לברירת המחדל של ה-AI",
          undo: "בטל",
          redo: "בצע מחדש",
          shortcut: {
            split: "S",
            mergeNext: "M",
            mergePrev: "Shift+M",
            copy: "Ctrl+C",
            paste: "Ctrl+V",
            undo: "Ctrl+Z",
            redo: "Ctrl+Shift+Z",
          },
        },
      },
      toaster: {
        cropCopied: "המסגרת הועתקה",
        cropPasted: "המסגרת הודבקה ל-{n} סצנות",
        cropApplied: "המסגרת הוחלה על כל הסצנות",
        scenesMerged: "{n} סצנות מוזגו",
        sceneSplit: "הסצנה פוצלה",
        sceneReset: "הסצנה אופסה לברירת המחדל של ה-AI",
        clipboardEmpty: "אין מסגרת בלוח — העתק אחת קודם",
        nothingToMerge: "בחר 2+ סצנות סמוכות למיזוג",
        mergeNotContiguous: "הסצנות הנבחרות חייבות להיות סמוכות",
        queued: "העיבוד נוסף לתור — עקוב אחר ההתקדמות בתור",
        overlayApplying: "מחיל אוברליי…",
        overlayQueued: "החלת האוברליי נוספה לתור — עקוב אחר ההתקדמות בתור",
        nothingToSave: "אין שינויי סצנות ואין אוברליי — אין מה לשמור",
      },
      saveDialog: {
        title: "עיבוד וידאו מחדש",
        doneTitle: "הושלם",
        errorTitle: "שגיאה",
        message: "ההחלטות שלך מיושמות על הוידאו. הדבר עשוי לקחת מספר דקות.",
        done: "העיבוד הושלם. הוידאו יהיה זמין בקרוב.",
        error: "שמירה או עיבוד מחדש נכשלו. אנא נסה שוב.",
        backToContent: "חזרה לתוכן",
        close: "סגור",
      },
      errors: {
        loadFailed: "טעינת נתוני העריכה נכשלה",
        saveFailed: "שמירה נכשלה",
        splitOutOfRange: "הפלייהד חייב להיות בתוך הסצנה הנבחרת לפיצול",
      },
    },
    overlayTemplates: {
      title: "תבניות אוברליי",
      subtitle: "יצירה וניהול של תבניות שכבות אוברליי עבור ה-Reframer",
      new: "תבנית חדשה",
      empty: "אין תבניות עדיין. צור אחת כדי להתחיל.",
      colName: "שם",
      colElements: "אלמנטים",
      colUpdated: "עודכן",
      colActions: "פעולות",
      actionEdit: "ערוך",
      actionDuplicate: "שכפל",
      actionDelete: "מחק",
      duplicated: "התבנית שוכפלה",
      deleted: "התבנית נמחקה",
      deleteTitle: "מחק תבנית",
      deleteConfirm: 'למחוק את "{name}"? לא ניתן לבטל פעולה זו.',
      cancel: "ביטול",
      deleting: "מוחק…",
      back: "חזור",
      namePlaceholder: "שם התבנית (חובה)",
      unsaved: "שינויים לא שמורים",
      save: "שמור",
      saving: "שומר…",
      saved: "התבנית נשמרה",
      created: "התבנית נוצרה",
      undo: "בטל (Ctrl+Z)",
      redo: "בצע מחדש (Ctrl+Shift+Z)",
      untitled: "תבנית ללא שם",
      presets: {
        title: "בחר נקודת התחלה",
        blank: "ריק",
        blankDesc: "קנבס ריק — בנה מאפס",
        breakingNews: "חדשות שוברות",
        breakingNewsDesc: "כותרת מודגשת בתחתית המסך",
        lowerThird: "שורת תחתית",
        lowerThirdDesc: "שם + תפקיד בפינה הימנית-תחתית",
        watermark: "ווטרמארק",
        watermarkDesc: "לוגו וכיתוב בפינה הימנית-עליונה",
        skip: "דלג — התחל מריק",
      },
      layers: {
        header: "שכבות",
        empty: "אין שכבות עדיין",
        addText: "הוסף טקסט",
        addLogo: "הוסף לוגו",
        addGradient: "הוסף גרדיאנט",
        addShape: "הוסף צורה",
        typeText: "טקסט",
        typeLogo: "לוגו",
        typeGradient: "גרדיאנט",
        typeShape: "צורה",
      },
      toolbar: {
        centerH: "מרכז אופקית",
        centerV: "מרכז אנכית",
        fillCanvas: "מלא את הקנבס",
        bringForward: "הבא קדימה",
        sendBackward: "שלח אחורה",
        bringFront: "הבא לחזית",
        sendBack: "שלח לאחור",
        duplicate: "שכפל",
        delete: "מחק",
      },
      props: {
        position: "מיקום וגודל",
        rotation: "סיבוב",
        opacity: "שקיפות",
        zOrder: "סדר Z",
        selectPrompt: "בחר אלמנט לעריכת מאפייניו.",
        typeProperties: "מאפייני {type}",
      },
      text: {
        header: "טקסט",
        label: "תווית",
        defaultText: "טקסט ברירת מחדל",
        font: "גופן",
        size: "גודל (px)",
        weight: "משקל",
        weightBold: "מודגש",
        weightNormal: "רגיל",
        align: "יישור",
        color: "צבע",
        shadow: "צל",
        shadowOffsetX: "הזזה X",
        shadowOffsetY: "הזזה Y",
        shadowBlur: "טשטוש",
        outline: "מתאר",
        outlineWidth: "רוחב",
      },
      logo: {
        header: "לוגו (נעול לתבנית — רק הטקסט דינמי)",
        upload: "העלה לוגו",
        replace: "החלף לוגו",
        uploading: "מעלה…",
        resetAspect: "אפס ליחס המקורי",
        resetting: "מאפס…",
      },
      gradient: {
        header: "גרדיאנט",
        direction: "כיוון (מעלות)",
        stops: "עצירות — לחץ על הסרגל להוספה, על נקודה לעריכה",
        color: "צבע",
        alpha: "שקיפות",
        remove: "הסר",
      },
      shape: {
        header: "צורה",
        fill: "מילוי",
        alpha: "שקיפות",
        radius: "רדיוס פינה (px)",
      },
    },
    overlayPicker: {
      enable: "הוסף שכבת אוברליי",
      selectTemplate: "בחר תבנית",
      noTemplates: "אין תבניות. צור אחת קודם.",
      texts: "תוכן טקסט",
      timing: "הצג אוברליי",
      timingFull: "לכל אורך הסרטון",
      timingFromStart: "N השניות הראשונות",
      timingRange: "טווח",
      start: "התחלה (שנ׳)",
      end: "סיום (שנ׳)",
      required: "כל שדות הטקסט הם חובה",
    },
    seo: {
      title: "RankLens",
      subtitle: "ניתוח SEO ו-GEO — {n} בדיקות על פני טכני, תוכן ונראות AI",
      urlPlaceholder: "הכנס כתובת כתבה (למשל https://reshet13.co.il/...)",
      analyze: "נתח",
      analyzing: "מנתח {n} אותות SEO ו-GEO... עד 60 שניות",
      emptyTitle: "הדבק כתובת URL להתחלה",
      emptySubtitle: "RankLens בודק {n} אותות בשלושה עמודים לניקוד נראות הכתבה שלך.",
      pillarTechnical: "SEO טכני",
      pillarContent: "איכות תוכן",
      pillarGeo: "אותות GEO",
      scores: {
        overallScore: "ציון כולל",
        seoScore: "SEO טכני",
        contentScore: "איכות תוכן",
        geoScore: "אותות GEO",
        filterHint: "לחץ על עמוד לסינון ממצאים",
      },
      fixes: {
        priorityTitle: "תיקונים בעדיפות גבוהה",
      },
      checks: {
        checksTitle: "דוח בדיקות מלא",
        seoCategory: "SEO טכני",
        contentCategory: "איכות תוכן",
        geoCategory: "אותות GEO",
      },
      reAnalyze: "נתח מחדש",
      quickWins: {
        title: "ניצחונות מהירים",
      },
      findings: {
        title: "ממצאים",
        issuesSuffix: "בעיות",
        failSuffix: "כשלונות",
        warnSuffix: "אזהרות",
        passedSuffix: "עברו",
        checksPassed: "בדיקות עברו",
        whyLabel: "למה זה חשוב",
        howLabel: "איך לתקן",
        optimalLabel: "אופטימלי",
        noIssues: "כל הבדיקות עברו",
        clearFilter: "נקה סינון",
        seoCategory: "SEO טכני",
        contentCategory: "איכות תוכן",
        geoCategory: "אותות GEO",
        performanceCategory: "ביצועים",
        geoContentGroup: "ניתן לשיפור עם AI",
        geoWebsiteGroup: "תיקונים ברמת הפלטפורמה",
        platformMetadataDisclaimer: "תיקונים אלו אינם ניתנים ליישום ישיר ב-CMS. הם מיוצרים ומוטמעים כמטא-דאטה מאומת בחבילת הכתבה — סכמות, נתונים מובנים ותגי מטא — מוכנים לצריכה ורינדור על ידי כל פלטפורמת פרסום.",
      },
      teaser: {
        title: "שיפור עם AI",
        badge: "בטא",
        subtitle: "כתוב מחדש את הכתבה לתיקון בעיות ברמת התוכן — הגדרות ישות, מבנה תשובה-ראשונה, ייחוס מקורות ועוד. תיקונים מבניים נשמרים כמטא-דאטה מאומת בחבילת הכתבה.",
        cta: "שפר עם AI",
        ctaLoading: "מייצר...",
        ctaSuccess: "עקוב בתור",
        disclaimer: "תיקוני תוכן מיושמים ישירות. תיקונים מבניים — סכמות, תגי מטא ונתונים מובנים — מוטמעים כמטא-דאטה מאומת בחבילת הכתבה, מוכנים לפלטפורמת הפרסום שלך.",
        platformDisclaimer: "בעיות ברמת הפלטפורמה — הפניות, כותרות תגובה, robots.txt, ביצועי Core Web Vitals — אינן בתחום הטיפול של כלי זה ומחייבות שינויים בשרת האינטרנט או בפלטפורמת ה-CMS שלך.",
        failingIssues: (n) => `${n} בעיות`,
        warningIssues: (n) => `${n} אזהרות`,
        impactPoints: (n) => `עד ${n} נקודות לשחזור`,
        video: {
          title: "יצירה מהווידאו",
          badge: "בטא",
          subtitle: "זו לא כתבה, בואו ניצור אחת. נחלץ את תוכן הווידאו וניצור ממנו כתבה מלאה.",
          cta: "צור מהווידאו",
          ctaLoading: "מייצר...",
          ctaSuccess: "עקוב בתור",
          disclaimer: "יוצר כתבה חדשה ומותאמת GEO מהווידאו המוטמע. הטקסט המקורי מוחלף.",
          platformDisclaimer: "בעיות ברמת הפלטפורמה — הפניות, כותרות תגובה, robots.txt, ביצועי Core Web Vitals — אינן בתחום הטיפול של כלי זה.",
        },
      },
    },
    todaybefore: {
      title: "היום לפני",
      subtitle: "מה קרה בתאריך הזה — הפיכת רגע מההיסטוריה לכתבה",
      refresh: "רענון היום",
      refreshing: "מרענן…",
      yearsAgo: "לפני {n} שנים",
      generate: "יצירת כתבה",
      openSource: "פתיחת המקור",
      openArticle: "פתיחת הכתבה",
      empty: "אין אירועים להיום",
      emptyHint: "לא נמצאו אירועים לתאריך הזה בוויקיפדיה ובפיד הכנסת.",
      sources: {
        wikipedia: "ויקיפדיה",
        knesset: "הכנסת",
      },
      state: {
        generating: "בתהליך יצירה…",
        generated: "הכתבה מוכנה",
      },
      confirm: {
        title: "ליצור כתבה?",
        message: "תיכתב כתבה בעברית על בסיס האירוע הזה. התהליך אורך כמה דקות.",
        cancel: "ביטול",
        confirm: "יצירה",
      },
      toaster: {
        queued: "יצירת הכתבה נכנסה לתור",
        alreadyQueued: "כבר נוצרת כתבה לאירוע הזה",
        failed: "יצירת הכתבה נכשלה",
        refreshed: "אירועי היום עודכנו",
        refreshFailed: "רענון אירועי היום נכשל",
      },
    },
    trendscout: {
      title: "TrendScout",
      subtitle: "סיפורים חמים מרחבי העולם, בסינון של AI",
      tabs: {
        articles: "כתבות",
        settings: "הגדרות",
      },
      status: {
        lastScan: "סריקה אחרונה:",
        scanNow: "סרוק עכשיו",
        never: "טרם בוצעה סריקה — לחץ להפעלה",
        scanning: "סורק…",
        scheduler: {
          active: "פעיל",
          disabled: "מושבת",
        },
      },
      relative: {
        now: "ממש עכשיו",
        secAgo: " שנ׳",
        minAgo: "דק׳",
        hAgo: " שע׳",
        dAgo: " ימים",
      },
      filters: {
        searchPlaceholder: "חיפוש לפי כותרת…",
        countries: "מדינות",
        countriesEmpty: "אין מדינות זמינות",
        clear: "נקה",
        rtlToggle: "ימין לשמאל",
        all: "הכול",
        written: "נכתבו",
        writtenTip: "הצג רק סיפורים שכבר הפכו לכתבות",
        sortHot: "הכי חם",
        sortNew: "הכי חדש",
      },
      card: {
        write: "כתוב כתבה",
        writing: "בכתיבה…",
        written: "הכתבה מוכנה",
        taken: "כבר נכתבה",
        failed: "נכשל",
        retry: "נסה שוב",
        failedHint: "הניסיון האחרון נכשל. לא נכתבה כתבה.",
        open: "פתח טיוטה",
        openSource: "קרא את המקור",
        scoreTip: "פוטנציאל קליקים: {n} מתוך 10",
        writingHint: "רץ ברקע — הכרטיס יתעדכן לבד.",
      },
      table: {
        title: "כותרת",
        description: "תיאור",
        source: "מקור",
        tags: "תגיות",
        published: "פורסם",
        actions: "פעולות",
        empty: "אין עדיין סיפורים חמים.",
        noMatches: "אין סיפורים שתואמים לחיפוש או לסינון.",
        noMatchesHint: "נסה כותרת אחרת או נקה את הסינון.",
        nextScanIn: "הסריקה הבאה בעוד {n} דקות.",
        pageOf: "עמוד {n} מתוך {m}",
        totalLabel: "סה״כ {n}",
        prevPage: "עמוד קודם",
        nextPage: "עמוד הבא",
      },
      coverage: {
        heading: "כיסוי",
        help: "בחר את המדינות והנושאים ש-TrendScout ינטר.",
        countries: "מדינות",
        topics: "נושאים",
        selectAll: "בחר הכל",
        clear: "נקה",
        summary: "{c}/{tc} מדינות · {t}/{tt} נושאים נבחרו",
        summaryCountries: "{c} מתוך {tc} נבחרו",
        save: "שמור שינויים",
        saving: "שומר…",
        discard: "בטל",
        browseCountries: "עיין בכל המדינות ({n})",
        modalTitle: "בחר מדינות",
        searchPlaceholder: "חיפוש לפי שם או קוד…",
        noResults: "לא נמצאו מדינות תואמות.",
        noCountriesSelected: "טרם נבחרו מדינות — עיין כדי להוסיף.",
        done: "סיום",
      },
      confirmGenerate: {
        title: "ליצור כתבה מהסיפור הזה?",
        message:
          "TrendScout יחקור את הסיפור ויכתוב כתבה מלאה בעברית. התהליך רץ ברקע כמה דקות — הכרטיס הזה עוקב אחריו והופך לקישור לטיוטה.",
        cancel: "ביטול",
        confirm: "צור כתבה",
      },
      topicNames: {
        WORLD: "עולם",
        // מקומי ולא "מהארץ": זה מדור החדשות הפנימי של מדינת המקור, לא של ישראל.
        NATION: "מקומי",
        BUSINESS: "כסף",
        TECHNOLOGY: "טכנולוגיה",
        ENTERTAINMENT: "בידור ורכילות",
        SPORTS: "ספורט",
        SCIENCE: "מדע",
        HEALTH: "בריאות ולייפסטייל",
      },
      duration: { ms: "מ״ש", s: "שנ׳", m: "דק׳" },
      toaster: {
        refreshTriggered: "הסריקה נוספה לתור — מתעדכן בקרוב.",
        refreshFailed: "לא ניתן היה להפעיל סריקה.",
        fetchFailed: "טעינת נתוני TrendScout נכשלה.",
        saveSuccess: "הכיסוי עודכן.",
        saveError: "לא ניתן לשמור את הכיסוי.",
        generationQueued: "הכתיבה התחילה — הכרטיס יתעדכן לבד כשהטיוטה תהיה מוכנה.",
        generationFailed: "לא ניתן היה לשלוח את הכתבה ליצירה.",
        generationAlreadyQueued: "הכתבה כבר נשלחה ליצירה.",
      },
    },
    FourOFour: {
      title: "404",
      description: "לא הצלחנו למצוא את הדף שחיפשת.",
    },
    FourOOne: {
      title: "401",
      description: "מצטערים, לחשבון שלך אין את הגישה הנדרשת.",
    },
    users: {
      title: "משתמשים",
      subtitle: "ניהול משתמשים, תפקידים והרשאות",
      new: { long: "משתמש חדש", short: "חדש" },
      search: { placeholder: "חיפוש לפי שם או דוא\"ל" },
      columns: {
        name: "שם",
        email: "דוא\"ל",
        role: "תפקיד",
        group: "קבוצה",
        active: "פעיל",
        actions: "פעולות",
      },
      roles: { admin: "מנהל", user: "משתמש" },
      status: { active: "פעיל", inactive: "לא פעיל" },
      actions: {
        edit: "ערוך משתמש",
        resetPassword: "אפס סיסמה",
        toggleActive: "שנה פעילות",
      },
      activeTooltip: {
        on: "לחץ להפיכה ללא פעיל",
        off: "לחץ להפיכה לפעיל",
      },
      groupPlaceholder: "(ללא קבוצה)",
      dialogs: {
        create: {
          title: "משתמש חדש",
          name: "שם",
          email: "דוא\"ל",
          password: "סיסמה ראשונית",
          role: "תפקיד",
          group: "קבוצה (אופציונלי)",
          active: "פעיל",
          cancel: "ביטול",
          create: "צור",
        },
        edit: {
          title: "ערוך משתמש",
          name: "שם",
          email: "דוא\"ל",
          role: "תפקיד",
          group: "קבוצה",
          active: "פעיל",
          cancel: "ביטול",
          save: "שמור",
        },
        resetPassword: {
          title: "איפוס סיסמה",
          message: "הגדר סיסמה חדשה למשתמש זה.",
          newPassword: "סיסמה חדשה",
          cancel: "ביטול",
          confirm: "אפס",
        },
      },
      toaster: {
        created: "המשתמש נוצר",
        updated: "המשתמש עודכן",
        passwordReset: "הסיסמה אופסה",
        activated: "המשתמש הופעל",
        deactivated: "המשתמש כובה",
        loadFailed: "טעינת המשתמשים נכשלה",
        error: "הפעולה נכשלה",
      },
    },
    statistics: {
      title: "סטטיסטיקות",
      subtitle: "ניתוח ייצור תוכן לפי מקור, חודש ומשתמש",
      filters: {
        from: "מתאריך",
        to: "עד תאריך",
        user: "משתמש",
        source: "מקור",
        apply: "החל",
        clear: "נקה",
        allUsers: "כל המשתמשים",
        allSources: "כל המקורות",
        excludeAdmins: "ללא מנהלים",
      },
      kpis: {
        total: "סה\"כ תוכן",
        downloaded: "הורדו",
        published: "פורסמו",
        downloadedNotPublished: "הורדו אך לא פורסמו",
      },
      charts: {
        byMonth: "לפי חודש",
        bySource: "לפי מקור",
        empty: "אין נתונים לסינון זה",
      },
      table: {
        title: "לפי משתמש",
        user: "שם",
        email: "דוא\"ל",
        downloads: "הורדות",
        publishes: "פרסומים",
        byArticle: "לפי מאמר",
        article: "מאמר",
        lastDownload: "הורדה אחרונה",
        actions: "פעולות",
        viewHistory: "היסטוריית הורדות",
      },
      sources: {
        TEXT: "טקסט",
        VIDEO: "וידאו",
        MANUAL: "ידני",
        REFRAMER: "ריפריימר",
        URL_REWRITER: "URL Rewriter",
      },
      downloadsDialog: {
        title: "היסטוריית הורדות",
        empty: "אין הורדות עדיין",
        close: "סגור",
        columns: {
          user: "משתמש",
          email: "אימייל",
          date: "תאריך",
        },
      },
      toaster: {
        loadFailed: "טעינת הסטטיסטיקות נכשלה",
      },
    },
    profile: {
      title: "הפרופיל שלי",
      subtitle: "ניהול החשבון שלך",
      fields: {
        name: "שם",
        email: "דוא\"ל",
        role: "תפקיד",
        group: "קבוצה",
      },
      save: "שמור",
      cancel: "ביטול",
      close: "סגור",
      changePassword: {
        title: "שינוי סיסמה",
        current: "סיסמה נוכחית",
        next: "סיסמה חדשה",
        confirm: "אשר",
      },
      toaster: {
        saved: "הפרופיל עודכן",
        passwordChanged: "הסיסמה שונתה",
        error: "הפעולה נכשלה",
      },
    },
    editor: {
      title: "עורך תוכן",
      subtitle: "צור וערוך תוכן",
      save: "שמור",
      publish: "פרסם",
      metadata: "מטא-דאטה",
      download: "הורד",
      drawer: {
        title: "מטא-דאטה",
        description: "צפה וערוך מטא-דאטה של התוכן",
        form: {
          title: "כותרת",
          tags: "תגיות",
          tagsPlaceholder: "חיפוש תגיות…",
          banner: "באנר",
          description: "תיאור",
          preview: "תצוגה מקדימה",
          general: "כללי",
        },
      },
      toaster: {
        contentId: "מזהה תוכן חסר",
        error: "אירעה שגיאה לא ידועה",
        length: "התוכן ריק",
        success: "הכתבה נשמרה",
        publishSuccess: "המאמר פורסם",
        publishFailed: "פרסום נכשל",
      },
      ai: {
        title: "עוזר עריכה",
        close: "סגור",
        newChat: "שיחה חדשה",
        empty:
          "בקש שינוי. סמן טקסט בכתבה כדי להפנות את העוזר אליו.",
        suggestions: ["לקצר את הפתיח", "לתקן ניסוח", "לחדד את הפסקה"],
        placeholder: "בקש שינוי…",
        thinking: "חושב",
        elapsed: "{{seconds}} שנ׳",
        hint: "Enter לשליחה · Shift+Enter לשורה חדשה",
        send: "שלח",
        change: "שינוי",
        oneChange: "שינוי אחד מוצע",
        changes: "{{count}} שינויים מוצעים",
        apply: "החל",
        reject: "דחה",
        applyAll: "החל הכל",
        rejectAll: "דחה הכל",
        stale: "הטקסט שאליו התייחס השינוי הזה השתנה מאז.",
        dropped:
          "{{count}} הצעות נוספות לא הותאמו למקום יחיד בכתבה.",
        failed: "לא ניתן להגיע לעוזר",
      },
    },
    content: {
      title: "תוכן",
      subtitle: "ייצור וניהול תוכן",
      search: {
        placeholder: "חיפוש לפי כותרת...",
        empty: "לא נמצאו תוצאות עבור",
      },
      pagination: {
        rowsPerPage: "שורות בעמוד:",
        of: "מתוך",
        nextPage: "העמוד הבא",
        previousPage: "העמוד הקודם",
      },
      filter: {
        source: "מקור",
        tags: "תגיות",
        tagsPlaceholder: "סינון לפי תגיות…",
        tagsEmpty: "אין תגיות תואמות",
        clear: "נקה",
        empty: "אין מקורות זמינים",
        sources: {
          manual: "ידני",
          text: "טקסט",
          video2article: "וידאו",
          reframer: "המרה וורטיקלית",
          "url-rewriter": "RankLens",
          "content-creator": "יוצר תוכן",
        },
        status: {
          label: "סטטוס",
          all: "הכל",
          published: "פורסם",
          unpublished: "לא פורסם",
        },
      },
      unpublishDialog: {
        title: "לסמן כלא פורסם?",
        message: "האם אתה בטוח שברצונך לסמן מאמר זה כלא פורסם? תוכל לסמן אותו כפורסם שוב בכל עת.",
        cancel: "ביטול",
        confirm: "אישור",
      },
      deleteDialog: {
        title: "למחוק את המאמר?",
        message: "המאמר יוסר מהרשימה. אם תזדקקו לו בחזרה, פנו למנהל המערכת.",
        cancel: "ביטול",
        confirm: "מחק",
      },
      publishedTooltip: {
        on: "פורסם",
        off: "טיוטה",
        readOnly: "פתחו את המאמר כדי לפרסם",
      },
      actions: {
        edit: "ערוך",
        editReframe: "ערוך וידאו",
        download: "הורד",
        downloadRequiresPublish: "סמנו כפורסם כדי לאפשר הורדה",
        delete: "מחק",
      },
      toaster: {
        unauthorized: "גישה לא מורשית",
        error: "אירעה שגיאה לא ידועה",
        delete: "התוכן נמחק",
        create: "התוכן נוצר",
        deploy: "התוכן הועלה",
        launch: "התוכן הושק",
        bind: "המאמר נוסף לאתר בהצלחה",
        downloadUnavailable: "הורדה אינה זמינה כרגע עבור סוג תוכן זה",
        downloadRequiresPublish: "יש לסמן את הכתבה כפורסמה לפני ההורדה",
      },
      new: {
        short: "חדש",
        long: "תוכן חדש",
      },
      popup: {
        save: "צור",
        cancel: "ביטול",
        title: "צור תוכן",
        [contentFactoryMap.article]: {
          title: "צור מאמר חדש",
          articleTitle: "כותרת",
          success: "התוכן נוצר בהצלחה.",
        },
        [contentFactoryMap.contentCreator]: {
          title: "צור תוכן",
          prompt: "פרומפט",
          success: "התוכן נוסף לתור בהצלחה.",
          promptHelper:
            "ספק פרומפט, וה-AI ייצור עבורך מאמר. זכור, ככל שהפרומפט שלך מפורט יותר, כך התוצאות יהיו טובות יותר.",
          language: "שפה",
          languageHelper: "בחר את שפת הפלט.",
          languages: {
            auto: "אוטומטי",
            en: "אנגלית",
            he: "עברית",
          },
          contentType: "סוג תוכן",
          contentTypeHelper: "בחר את קטגוריית התוכן.",
          contentTypes: {
            auto: "אוטומטי",
            news: "חדשות",
            entertainment: "בידור",
            explainer: "מסביר",
          },
          minLength: "מספר מילים מינימלי",
          maxLength: "מספר מילים מקסימלי",
          lengthHelper: "הגדר את טווח ספירת המילים.",
          maxSources: "מקורות מקסימליים",
          maxSourcesHelper: "קבע את יסודיות המחקר.",
          noImages: "ללא תמונות",
          noImagesHelper: "דלג על עיבוד תמונה.",
        },
        [contentFactoryMap.reframer]: {
          title: "המרה וורטיקלית",
          name: "שם",
          success: "הוידאו נוסף לתור ההמרה בהצלחה.",
        },
        [contentFactoryMap.videoContentCreator]: {
          title: "יוצר תוכן וידאו",
          success: "הוידאו נוספו לתור הייצור בהצלחה.",
          alert:
            "העלה קובץ וידאו אחד או יותר וה-AI ייצור מאמר בעברית עם צילומי מסך מופקים לכל וידאו.",
          fileHelper: "רק קבצי וידאו מקובלים (MP4, AVI, MOV וכו')",
          uploadVideo: "הוסף וידאו",
          paragraphsLabel: "פסקאות",
          paragraphsHelper: "מספר פסקאות יעד לכל מאמר שייווצר.",
        },
      },
      drawer: {
        title: "תוכן חדש",
        description: "בחר את סוג התוכן שברצונך ליצור",
        types: [
          {
            id: contentFactoryMap.article,
            title: "מאמר",
            description: "צור מאמר חדש באמצעות עורך טקסט עשיר",
          },
          // יוצר תוכן (Content Creator) — hidden; see en.js for context.
          // {
          //   id: contentFactoryMap.contentCreator,
          //   title: "יוצר תוכן",
          //   description: "צור תוכן על ידי הנחיית AI",
          // },
          {
            id: contentFactoryMap.videoContentCreator,
            title: "יוצר תוכן וידאו",
            description: "צור תוכן על ידי העלאת קבצי וידאו",
          },
          {
            id: contentFactoryMap.reframer,
            title: "המרה וורטיקלית",
            description: "המר וידאו לפורמט וורטיקלי",
          },
        ],
      },
    },
    configurations: {
      title: {
        short: "הגדרות",
        long: "הגדרות אתר",
      },
      subtitle: "ערוך, פרסם והתאם אישית את האתר",
      description: "תיאור SEO של האתר",
      template: "תבנית",
      categories: "קטגוריות",
      republish: "פרסם מחדש",
      add: {
        short: "הוסף",
        long: "הוסף מאמר",
      },
      addCategory: "הוסף",
      error: "אירעה שגיאה לא ידועה",
      empty: "אין מאמרים מקושרים לאתר זה",
      delete: "מחק",
      edit: "ערוך קטגוריה",
      none: "ריק",
      editMeta: "ערוך קבצי מטא",
      success: "מקוון",
      failure: "ריק",
      maxFeatured: "חרגת ממספר המאמרים המודגשים המקסימלי (5)",
      addQueue: "הפעולה נוספה לתור בהצלחה",
      search: {
        placeholder: "חיפוש לפי כותרת...",
        empty: "לא נמצאו תוצאות עבור",
      },
      drawer: {
        title: "הוסף מאמר",
        description: "הוסף מאמר חדש לאתר",
        empty: "אין מאמרים להצגה",
      },
      fileDrawer: {
        title: "עריכה",
        description:
          "קבצים הם רכיבי ליבה של האתר, המשמשים לאימות האתר, ניהול פרסומות, SEO ותוכן כללי",
      },
      txtDrawer: {
        title: "ערוך קבצי מטא",
        description:
          "קבצי מטא הם סטים של נתונים התומכים בפרסומות, SEO ותוכן כללי של האתר",
        mediaAlert: "כתוב את כתובת ה-URL של קובץ המדיה מ-S3 bucket",
        robots: "Robots.txt",
        ads: "Ads.txt",
        logo: "Logo.svg",
        favicon: "Favicon",
        sitemap: "Sitemap.xml",
        files: "קבצים",
        media: "מדיה",
        about: "אודות",
        privacy: "מדיניות פרטיות",
        terms: "תנאי שימוש",
        contact: "צור קשר",

        structure: "מבנה",
      },
      dialog: {
        title: "הוסף קטגוריה",
        cancel: "ביטול",
        save: "שמור",
      },
    },
    contentNew: {
      title: "חדש",
      action: "שנה סוג",
    },
    sites: {
      title: "אתרים",
      subtitle: "ניהול האתרים שלך",
      alert: "הדף בפיתוח - יתווסף רשימת אתרים",
    },
    404: {
      title: "404",
      description: "הדף לא נמצא",
    },
  },
  layout: {
    sidebar: {
      settings: "הגדרות",
      quickActions: "פעולות מהירות",
      siteName: "LT Solutions",
      profile: ["שנה ערכת נושא", "English", "הפרופיל שלי", "התנתק"],
    },
  },
  components: {
    uploadArea: {
      subtitle: "גרור ושחרר קבצים לכאן, או לחץ לבחירת קבצים",
    },
    markdownEditor: {
      // Toolbar Undo/Redo
      "toolbar.undo": "בטל", // Undo
      "toolbar.redo": "בצע שוב", // Redo

      // Text formatting
      "toolbar.bold": "מודגש", // Bold
      "toolbar.removeBold": "הסר הדגשה", // Remove bold
      "toolbar.italic": "נטוי", // Italic
      "toolbar.removeItalic": "הסר נטוי", // Remove italic
      "toolbar.underline": "קו תחתון", // Underline
      "toolbar.removeUnderline": "הסר קו תחתון", // Remove underline

      // Block types
      "toolbar.blockTypes.paragraph": "פסקה", // Paragraph
      "toolbar.blockTypes.quote": "ציטוט", // Quote
      "toolbar.blockTypes.heading": "כותרת {{level}}", // Heading with level
      "toolbar.blockTypeSelect.selectBlockTypeTooltip": "בחר סוג בלוק", // Select block type
      "toolbar.blockTypeSelect.placeholder": "סוג בלוק", // Block type

      // Lists
      "toolbar.bulletedList": "רשימה עם תבליטים", // Bulleted list
      "toolbar.numberedList": "רשימה ממוספרת", // Numbered list
      "toolbar.checkList": "רשימת סימון", // Check list

      // Thematic break
      "toolbar.thematicBreak": "הוסף קו מפריד", // Insert thematic break
      "toolbar.toggleGroup": "קבוצת לחצנים", // toggle group

      // Image upload
      "uploadImage.dialogTitle": "העלאת תמונה", // Upload an image
      "uploadImage.addViaUrlInstructionsNoUpload": "הוסף תמונה מכתובת URL:", // Add an image from an URL
      "uploadImage.autoCompletePlaceholder": "בחר או הדבק כתובת תמונה", // Select or paste an image src
      "uploadImage.alt": "טקסט חלופי:", // Alt:
      "uploadImage.title": "כותרת:", // Title:

      // Dialog controls
      "dialogControls.save": "שמור", // Save
      "dialogControls.cancel": "ביטול", // Cancel
    },
    mediaEditor: {
      image: {
        title: "ערוך תמונה",
        close: "סגור",
        saving: "שומר...",
        uploadFailed: "טעינת התמונה הערוכה נכשלה",
        filerobot: {
          name: "שם",
          save: "שמור",
          saveAs: "שמור בשם",
          back: "חזרה",
          loading: "טוען...",
          resetOperations: "אפס הכל",
          changesLoseWarningHasChanges: "יש שינויים שלא נשמרו.",
          discardChanges: "בטל שינויים",
          continue: "המשך",
          adjustTab: "כוונון",
          finetuneTab: "עידון",
          filtersTab: "פילטרים",
          watermarkTab: "סימן מים",
          annotateTab: "הערות",
          resizeTab: "שינוי גודל",
          cropTool: "חיתוך",
          rotateTool: "סיבוב",
          flipTool: "היפוך",
          original: "מקורי",
          custom: "מותאם",
          landscape: "רוחבי",
          portrait: "אנכי",
          square: "ריבוע",
          brightness: "בהירות",
          contrast: "ניגודיות",
          saturation: "רוויה",
          exposure: "חשיפה",
          hue: "גוון",
          warmth: "חמימות",
          lighten: "הארה",
          sharpness: "חדות",
          blur: "טשטוש",
          gamma: "גמא",
          addTextPlaceholder: "הוסף טקסט",
          width: "רוחב",
          height: "גובה",
          aspectRatioLockTip: "נעל / שחרר יחס",
          undo: "בטל",
          redo: "בצע שוב",
          download: "הורד",
          cancel: "ביטול",
          apply: "החל",
          addWatermarkTitle: "הוסף סימן מים",
          watermarkLink: "קישור",
          addWatermarkAsText: "כטקסט",
          addWatermarkAsImage: "כתמונה",
        },
      },
      video: {
        title: "ערוך וידאו",
        duration: "משך",
        start: "התחלה",
        end: "סוף",
        speed: "מהירות",
        mute: "השתק",
        cancel: "ביטול",
        save: "שמור",
        processing: "מעבד...",
        errorPrefix: "לא ניתן לערוך את הוידאו",
        invalidRange: "ההתחלה חייבת להיות לפני הסוף.",
      },
      toolbar: {
        editImage: "ערוך תמונה",
        editVideo: "ערוך וידאו",
        imageUrlPrompt: "כתובת URL של תמונה:",
        videoUrlPrompt: "כתובת URL של וידאו:",
      },
      confirmDelete: {
        title: "להסיר מהעורך?",
        imageBody:
          "הפעולה מסירה את התמונה מהמסמך בלבד. הקובץ נשאר באחסון וניתן להשתמש בו שוב.",
        videoBody:
          "הפעולה מסירה את הוידאו מהמסמך בלבד. הקובץ נשאר באחסון וניתן להשתמש בו שוב.",
        cancel: "ביטול",
        confirm: "הסר",
      },
      contextMenu: {
        editImage: "ערוך תמונה",
        editVideo: "ערוך וידאו",
        deleteImage: "מחק תמונה",
        deleteVideo: "מחק וידאו",
        copyUrl: "העתק כתובת URL",
        cut: "גזור",
        copy: "העתק",
        paste: "הדבק",
        undo: "בטל",
        redo: "בצע שוב",
        selectAll: "בחר הכל",
      },
    },
    gallery: {
      undefined: "קנה מידה לא ידוע",
      copy: "כתובת התמונה הועתקה ללוח",
      empty: "אין תמונות להצגה",
    },
    table: {
      empty: "אין נתונים להצגה",
      copyCell: "תוכן התא הועתק ללוח",
    },
  },
};

export default heb;
